import { useMsal } from "@azure/msal-react";
import { Field, FieldArray, Form, Formik } from 'formik';
import * as React from "react";
import { ComponentsHelper } from "../../core/services/ComponentHelper";
import { WORK_STATUS_LOOKUP } from "../../lookup/Consts";
import { getLookupValues } from "../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { MembersPortalService } from "../../redux/services/MembersPortalService";
import { FormatFields } from "../../redux/types/FormatFields";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { MemberPortalSearchType } from "../../redux/types/MemberPortalSearchType";
import { MemberPortalSearchTypeItem } from "../../redux/types/MemberPortalSearchTypeItem";
import { MembersPortalRoles } from "../../redux/types/MembersPortalRoles";
import ActionButton, { ActionButtonFormik } from "../../repertoire/components/actionButton/ActionButton";
import { SizedCheckboxDataInput } from "../../repertoire/components/checkboxDataInput/CheckboxDataInput";
import { CHECKBOX_INPUT, DROPDOWN_INPUT, PAGINATION, REPERTOIRE_PAGE_FORM_ITEM_SIZE } from "../../repertoire/Consts";
import { IMyPackagesResult } from "../../repertoire/types/IMyPackagesResult";
import { IRepertoireField } from "../../repertoire/types/IRepertoireField";
import { isMandatoryField } from "../../util/tools";
import { DatePickerComponent } from "../components/input/DatePickerComponent";
import { ADD_TO_PACKAGE_ACTION, INCLUDE_MY_WORKS_REGISTERED_ALL_MY_ACCOUNTS_KEY, INCLUDE_MY_WORKS_REGISTERED_VIA_OTHER_CHANNELS_KEY, INCLUDE_WORKS_ASSIGNED_TO_ME_VIA_AGREEMENTS_KEY, SEARCH_VIEW_DRAFT_WORKS } from "../Consts";
import DisplayTableSearchResults from "../sharedComponents/displayTableSearchResults/DisplayTableSearchResults";
import { IAssigneeAgreementResult } from "../types/IAssigneeAgreementResult";
import { IDraftWorkSearchResult } from "../types/IDraftWorkSearchResult";
import { IMembersPortalField } from "../types/IMembersPortalField";
import { IMemberStatementSearchResult } from "../types/IMemberStatementSearchResult";
import { IRegisteredWorkSearchQuery } from "../types/IRegisteredWorkSearchQuery";
import SelectAndSearchDropdown from "../components/input/SelectAndSearchDropdown";
import { showYesNoPrompt, hideModal } from "../../redux/reducers/ModalReducer";
import { AddToPackageProvider } from "../sharedComponents/button/AddToPackageContext";
import CreateFullCataloguePackageButton from "../sharedComponents/button/CreateFullCataloguePackageButton";
import { useAddToPackageContext } from "../sharedComponents/button/AddToPackageContext";


export interface IMemberWorksSearchViewProps {
    searchMemberWorks: (query: IRegisteredWorkSearchQuery, isModalOpen?: boolean) => void;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    memberWorkSearchResults: IDraftWorkSearchResult[];
    searchSuccessful: boolean;
    paymentStatementGeneralDataViewData?: IMembersPortalComponentDataItem;
    lookupValues: ILookupDictionary;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    getMemberStatementDetails?: (payment: IMemberStatementSearchResult, lookupValues: ILookupDictionary, userNameNumber: string, formats?: FormatFields[]) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    disabled?: boolean;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    memberPortalSearchType?: MemberPortalSearchTypeItem;
    currentUserNameNumber?: string;
    expandAllResults: () => void;
    expandAll: boolean;
    isSearching?: boolean;
    getMemberWorkDetails: (dataSource: string, workId: number, includeAllMyAccounts?: boolean) => void;
    dataSource: string;
    componentInstance: string;
    customer?: string;
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => IMyPackagesResult;
    getAssigneeAgreements?: () => void;
    assigneeAgreementsResult?: IAssigneeAgreementResult[];
    showYesNoPrompt?: typeof showYesNoPrompt;
    hideModal?: typeof hideModal;
    fullCataloguePackagePending?: boolean;
    saveInProgress?: boolean;
    createPackageFromCriteria?: (userName: string, criteria: IRegisteredWorkSearchQuery) => void;
}



const MemberWorksSearchView: React.FC<IMemberWorksSearchViewProps> = ({
    searchMemberWorks,
    searchViewData,
    searchSuccessful,
    searchResultsTableData,
    memberWorkSearchResults,
    currentUserNameNumber,
    indexOfFirstResult,
    indexOfLastResult,
    resultsPerPage,
    currentPage,
    resetPagination,
    updatePagination,
    lookupValues,
    sortSearchResults,
    getMemberWorkDetails,
    memberPortalSearchType,
    dataSource,
    tabs,
    activeTab,
    componentInstance,
    customer,
    addToPackages,
    getAssigneeAgreements,
    assigneeAgreementsResult,
    showYesNoPrompt,
    hideModal,
    fullCataloguePackagePending,
    createPackageFromCriteria,
    saveInProgress,
}) => {
    const [loaded, setLoaded] = React.useState(false);
    const [filteredFields, setFilteredFields] = React.useState<IRepertoireField[] | IMembersPortalField[]>([]);
    const [filteredSearchResults, setFilteredSearchResults] = React.useState<IRepertoireField[]>([]);
    const { instance, accounts } = useMsal();
    const [checkboxValues, setCheckboxValues] = React.useState<{ [key: string]: boolean }>({});
    const [dropdownValues, setDropdownValues] = React.useState<{ [key: string]: string | (string | number)[] }>({});
    const [assigneeAgreements, setAssigneeAgreements] = React.useState([]);
    const formikRef = React.useRef<any>(null);
    const { addedIds } = useAddToPackageContext();

    const hasPackageItems = addedIds.length > 0;

    React.useEffect(() => {
        setLoaded(true);
        const account = accounts[0]
        ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
    }, [])

    React.useEffect(() => {
        if (getAssigneeAgreements && memberPortalSearchType && memberPortalSearchType.code === MemberPortalSearchType.MyRegisteredSearch.code) {
            getAssigneeAgreements();
        }
    }, []);

    React.useEffect(() => {
        if (assigneeAgreementsResult && assigneeAgreementsResult.length > 0 && memberPortalSearchType && memberPortalSearchType.code === MemberPortalSearchType.MyRegisteredSearch.code) {
            setAssigneeAgreements(assigneeAgreementsResult);
        }
    }, [assigneeAgreementsResult]);

    React.useEffect(() => {
        if (searchViewData && searchViewData.fields) {
            let filteredSearchFields = searchViewData.fields.filter(
                (field: IRepertoireField | IMembersPortalField) =>
                    field.componentInstance === componentInstance
            );
            setFilteredFields(filteredSearchFields);
        }

        if (searchResultsTableData.fields) {
            let filteredFields = searchResultsTableData.fields.filter(
                (field: IRepertoireField) =>
                    field.componentInstance === componentInstance || field.componentInstance === PAGINATION
            );
            setFilteredSearchResults(filteredFields);
        }

    }, [searchViewData, searchResultsTableData, componentInstance])

    const buildRegisteredWorksCriteria = (values: {
        artist?: string;
        ipName?: string;
        ipNumber: string;
        workNumber: string;
        status: string;
        title: string;
        fromDate: string;
        toDate: string;
    }): IRegisteredWorkSearchQuery => {
        return {
            title: values.title,
            status: values.status,
            workNumber: values.workNumber,
            artist: values.artist,
            ipNumber: values.ipNumber,
            ipName: values.ipName,
            dataSource: dataSource,
            currentUserNameNumber: currentUserNameNumber,
            fromRegistrationDate: values.fromDate,
            toRegistrationDate: values.toDate,
            includeMyWorksRegisteredViaOtherChannels: checkboxValues[INCLUDE_MY_WORKS_REGISTERED_VIA_OTHER_CHANNELS_KEY] ?? true,
            includeMyWorksRegisteredAllMyAccounts: checkboxValues[INCLUDE_MY_WORKS_REGISTERED_ALL_MY_ACCOUNTS_KEY] ?? true,
            selectedAgreementIDs: Array.isArray(dropdownValues[INCLUDE_WORKS_ASSIGNED_TO_ME_VIA_AGREEMENTS_KEY])
                ? (dropdownValues[INCLUDE_WORKS_ASSIGNED_TO_ME_VIA_AGREEMENTS_KEY] as (string | number)[]).map(String)
                : dropdownValues[INCLUDE_WORKS_ASSIGNED_TO_ME_VIA_AGREEMENTS_KEY]
                    ? [String(dropdownValues[INCLUDE_WORKS_ASSIGNED_TO_ME_VIA_AGREEMENTS_KEY])]
                    : [String("All")],
        };
    };

    const onSearch = (values) => {
        resetPagination(componentInstance);
        const searchQuery = buildRegisteredWorksCriteria(values);
        searchMemberWorks(searchQuery);
    };


    const CustomInputComponent = ({
        field,
        form: { touched, errors },
        ...props
    }) => (
        <div>
            <input type="text" {...field} {...props} />
            {touched[field.name] &&
                errors[field.name] && <div className="error">{errors[field.name]}</div>}
        </div>
    );

    const renderSearchFields = () => {
        let filteredSearchFieldsMapper = (searchField: IRepertoireField | IMembersPortalField, index: number): React.ReactElement => {
            let formField: React.ReactElement = <></>;

            if ((searchField.fieldType === 'text' || searchField.fieldType === 'integer' || searchField.fieldType === 'decimal')) {
                formField = (
                    <div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE}>
                        <label>{`${searchField.data}:`}</label>
                        <Field label={`${searchField.data}`} name={`${searchField.name}`} component={CustomInputComponent} />
                    </div>
                );
            } else if (searchField.fieldType === 'date') {
                formField = (
                    <Field
                        name={`${searchField.name}`}
                        component={DatePickerComponent}
                        label={`${searchField.data}`}
                        isHidden={searchField.hidden}
                        isMandatory={isMandatoryField(searchField)}
                        placeholder={searchViewData.fields.find(v => v.name.toString() == 'selectDate')?.data}
                    />
                );
            } else if (searchField.fieldType === 'select_action') {
                let options: { code: string, description: string }[] = [];
                if (lookupValues && memberPortalSearchType.code === MemberPortalSearchType.AllRegisteredSearch.code) {
                    options.push({ code: null, description: "" });
                    options.push(
                        ...getLookupValues(WORK_STATUS_LOOKUP, lookupValues)
                            .filter(o => o.code !== "DRAFT" && o.code !== "DRAFTSUB")
                    );
                } else if (lookupValues && memberPortalSearchType.code === MemberPortalSearchType.MyRegisteredSearch.code) {
                    options.push({ code: null, description: "" });
                    options.push(
                        ...getLookupValues(WORK_STATUS_LOOKUP, lookupValues)
                            .filter(o => o.code !== "DRAFT" && o.code !== "DRAFTSUB")
                    );
                } else if (lookupValues && memberPortalSearchType.code === MemberPortalSearchType.MyDraftSearch.code) {
                    options = [
                        { code: null, description: "" },
                        { code: "DRAFT", description: "Draft" },
                        { code: "DRAFTSUB", description: "Draft Submitted" }
                    ];
                }

                formField = (
                    <div key={index} className={REPERTOIRE_PAGE_FORM_ITEM_SIZE}>
                        <label>{`${searchField.data}:`}</label>
                        <Field label={`${searchField.data}`} name={`${searchField.name}`} as="select">
                            {options.map(selectableOption => (
                                <option value={selectableOption.code}>{selectableOption.description}</option>
                            ))}
                        </Field>
                    </div>
                );
            } else if (
                searchField.fieldType === CHECKBOX_INPUT &&
                memberPortalSearchType.code === MemberPortalSearchType.MyRegisteredSearch.code
            ) {
                const value = checkboxValues[searchField.name] ??
                    (
                        searchField.name === INCLUDE_MY_WORKS_REGISTERED_VIA_OTHER_CHANNELS_KEY ||
                        searchField.name === INCLUDE_MY_WORKS_REGISTERED_ALL_MY_ACCOUNTS_KEY
                    );

                formField = (
                    <SizedCheckboxDataInput
                        label={searchField.data}
                        fieldName={searchField.name}
                        value={value}
                        changeData={(val) =>
                        	setCheckboxValues((prev) => ({
                                ...prev,
                                [searchField.name]: Boolean(val),
                        	}))
                        }
                        readonly={false}
                        />
                );
            } else if (
                searchField.fieldType === DROPDOWN_INPUT &&
                memberPortalSearchType.code === MemberPortalSearchType.MyRegisteredSearch.code
            ) {
                const dropdownValue = dropdownValues[searchField.name] ?? ["All"];
                const flatAssigneeAgreements = assigneeAgreements.flat();

                formField = (
                    <div key={index} className={REPERTOIRE_PAGE_FORM_ITEM_SIZE}>
                        <SelectAndSearchDropdown
                            label={searchField.data}
                            poolOptions={flatAssigneeAgreements.map(agreement => ({
                                key: String(agreement.key),
                                text: agreement.text
                            }))}
                            value={Array.isArray(dropdownValue) ? dropdownValue.map(String) : [String(dropdownValue)]}
                            onChange={(next: (string | number)[]) =>
                                setDropdownValues(prev => ({
                                    ...prev,
                                    [searchField.name]: next.map(String)
                                }))
                            }
                            disabled={false}
                            data-testid={searchField.name}
                            enableSearch={true}
                            placeholder={searchViewData.fields.find(v => v.name.toString() == 'search')?.data}
                        />
                    </div>
                );
            }
            return formField;
        };

        return (
            <FieldArray
                name="draftWorkForm"
                render={() => (
                    <div>
                        {filteredFields.length > 0
                            ? filteredFields.map(filteredSearchFieldsMapper)
                            : <>Loading...</>}
                    </div>
                )}
            />
        );
    };

    const handleSorting = (result) => {
        sortSearchResults(componentInstance, result)
    }

    const rowActions = () => ({
		iconButton: {
			icon: "icon ms-Icon ms-Icon--OpenInNewTab",
			onClick: (work) => {
				getMemberWorkDetails(
					dataSource,
					work.workID,
					checkboxValues[INCLUDE_MY_WORKS_REGISTERED_ALL_MY_ACCOUNTS_KEY] ?? true
				);
			}
		}
	});

    const menuName = tabs[activeTab]?.name;
    const hasPermission = MembersPortalService.hasPermissionForMenu(menuName, MembersPortalRoles.ReadOnlyAccess);

    if (loaded && filteredFields && filteredFields.length > 0) {
        return (
            <div className="searchView">
                <div key='searchFields' className="row">

                    <Formik
                        innerRef={formikRef}
                        initialValues={{
                            title: null,
                            status: null,
                            workNumber: null,
                            artist: null,
                            ipNumber: null,
                            ipName: null,
                            fromDate: null,
                            toDate: null,
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            onSearch(values)
                            setSubmitting(false);
                        }}
                    >
                        {({ isSubmitting, isValid, dirty }) => (
                            <Form>
                                <div key='searchFields' className="row paddingVeryLarge">
                                    {renderSearchFields()}
                                </div>

                                <div key="action" className="row">
                                    {memberPortalSearchType?.code === MemberPortalSearchType.MyRegisteredSearch.code && (
                                        <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                            <CreateFullCataloguePackageButton
                                                buttonText={searchViewData.fields.find(v => v.fieldType === ADD_TO_PACKAGE_ACTION && v.componentInstance === componentInstance)?.data}
                                                fullCataloguePackagePending={fullCataloguePackagePending}
                                                saveInProgress={saveInProgress}
                                                disabled={hasPackageItems}
                                                createPackageFromCriteria={createPackageFromCriteria}
                                                buildCriteria={() => buildRegisteredWorksCriteria(formikRef.current?.values || {})}
                                                searchViewData={searchViewData}
                                            />
                                        </div>
                                    )}
                                    <div className={
                                        memberPortalSearchType?.code === MemberPortalSearchType.MyRegisteredSearch.code
                                            ? "form-group col-lg-4 col-lg-offset-4 col-md-4 col-md-offset-4 col-sm-6 col-xs-12"
                                            : "form-group col-lg-4 col-lg-push-8 col-md-4 col-md-push-8 col-sm-6 col-sm-push-6 col-xs-12 col-xs-push-0"
                                    }>
                                        <ActionButtonFormik buttonText={searchViewData.fields.find(v => v.name == "search").data}
                                            isSubmitting={isSubmitting} isErrorInForm={!isValid && dirty}/>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                {(searchSuccessful || (memberWorkSearchResults && memberWorkSearchResults.length >= 1)) &&
                    <div key='results'>
                        <DisplayTableSearchResults
                            searchSuccessful={searchSuccessful}
                            searchResultsTableData={filteredSearchResults}
                            searchResults={memberWorkSearchResults}
                            indexOfFirstResult={indexOfFirstResult}
                            indexOfLastResult={indexOfLastResult}
                            resultsPerPage={resultsPerPage}
                            currentPage={currentPage}
                            updatePagination={updatePagination}
                            lookupValues={lookupValues}
                            resetPagination={resetPagination}
                            sortSearchResults={handleSorting}
                            rowActions={rowActions()}
                            addToPackages={addToPackages}
                            showYesNoPrompt={showYesNoPrompt}
                            hideModal={hideModal}
                            repertoireSection={componentInstance}
                            packageActionsDisabled={
                                Boolean(fullCataloguePackagePending)
                            }
                            packageMessageData={[
                                ...(searchResultsTableData?.fields ?? []),
                                ...(searchViewData?.fields ?? []),
                            ]}
                        />
                    </div>
                }
            </div>
        );
    }
    return <div>Loading ...</div>
}

export default MemberWorksSearchView;